<template>
  <div>
    <b-card :title="cardTitle">
      <b-row class="d-flex justify-content-center align-items-center">
        <b-col>
          <b-form-group
            label="Başlangıç Tarihi"
            label-for="sdate"
          >
            <b-form-datepicker
              v-bind="{labelNoDateSelected: 'Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="tr"
              start-weekday="1"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Bitiş Tarihi"
            label-for="edate"
          >
            <b-form-datepicker
              v-bind="{labelNoDateSelected: 'Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="tr"
              start-weekday="1"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BCol, BFormDatepicker, BFormGroup, BRow, BCard,
} from 'bootstrap-vue'

export default {
  name: 'SalesFilterCard',
  components: {
    BFormDatepicker, BFormGroup, BCol, BRow, BCard,
  },
  props: {
    cardTitle: {
      type: String,
      default: null,
    },
  },
}
</script>
